"use strict";

import $ from 'jquery';

window.dataLayer = window.dataLayer || [];

function gtag(){
    window.dataLayer.push(arguments);
}

document.addEventListener("DOMContentLoaded", function() {
    const rootEl = $('#contextRoot');
    const tagId = rootEl.data('analytics-code');
    const gTagUrl = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;

    $.getScript(gTagUrl, function() {
        gtag('js', new Date());
        gtag('config', tagId);
    });
});




// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/common/Analytics.js